//Mojo-AG
import React from "react";
import { DataGrid } from '@mui/x-data-grid';
import { connect } from 'react-redux';
import Button from '@mui/material/Button';
import CustomToolbar from '../Share/Table/CustomToolbar';
import ConfirmDialog from '../Share/ConfirmDialog';
import CreateCommissionSettings from './CreateCommissionSettings';
import EditCommissionSettings from './EditCommissionSettings';
import i18next from '../../language/i18n';
import DeleteButton from '../Share/Button/DeleteButton';
import { addDialogCommissionSettings, editDialogCommissionSettings, deleteCommissionSettings, getAllCommissionSettings } from "../../actions/commissionSettingsAction";
import { getSelectBoxPartners } from '../../actions/partnerAction';
import { getSelectBoxLoanTypes } from '../../actions/loanTypeAction';
import { dateFormat } from '../Share/Table/DateFormat';


class TableCommissionSettings extends React.Component {
  constructor(props) {
    super(props);
    this.state = { IsOpenConfirmDialog: false, ID: null }
  }
  componentDidMount = () => {
    this.props.getSelectBoxLoanTypes();

  }
  loanTypeName = (props) => {
    return this.props.loanTypes.find(el => el.value == props.row.loanTypeID)?.text;
  }
  columns = [
    {
      field: 'LoanTypeID',
      headerName: i18next.t('LoanType'),
      width: 160,
      valueGetter: this.loanTypeName,
      sortComparator: (v1, v2, cellParams1, cellParams2) =>
        this.loanTypeName(cellParams1).localeCompare(this.loanTypeName(cellParams2))
    },
    { field: 'validFrom', headerName: i18next.t('ValidFrom'), minWidth: 120, flex: 1, valueGetter: dateFormat },
    { field: 'validTo', headerName: i18next.t('ValidTo'), minWidth: 120, flex: 1, valueGetter: dateFormat },
    { field: 'fromLoanTermMonths', headerName: i18next.t('FromLoanTermMonths'), minWidth: 100, flex: 1 },
    { field: 'toLoanTermMonths', headerName: i18next.t('ToLoanTermMonths'), minWidth: 100, flex: 1 },
    { field: 'fromRequestedAmount', headerName: i18next.t('FromRequestedAmount'), minWidth: 150, flex: 1 },
    { field: 'toRequestedAmount', headerName: i18next.t('ToRequestedAmount'), minWidth: 150, flex: 1 },
    { field: 'percentage', headerName: i18next.t('Percentage'), minWidth: 100, flex: 1 },
    { field: 'createDate', headerName: i18next.t('CreateDate'), minWidth: 150, flex: 1, valueGetter: dateFormat },
    { field: 'editDate', headerName: i18next.t('EditDate'), minWidth: 150, flex: 1, valueGetter: dateFormat },

    {
      field: 'edit',
      headerName: ' ',
      renderCell: (params) => (
        <strong>
          <Button
            variant="contained"
            color="primary"
            size="small"
            style={{ marginLeft: 16 }}
            onClick={() => this.edit(params)}
          >
            {i18next.t('Edit')}
          </Button>
        </strong>
      ),
    },
    {
      field: 'delete',
      headerName: ' ',
      renderCell: (params) => (
        <strong>
          <DeleteButton onClick={() => this.delete(params)} />
        </strong>
      )
    }
  ];
  create = () => {
    this.props.addDialogCommissionSettings();
  }
  edit = (params) => {
    this.props.editDialogCommissionSettings(params.row);
  }
  delete = (params) => {
    this.setState({ IsOpenConfirmDialog: true, ID: params.row.id });
  }
  render() {
    return (
      <div style={{ height: 700, width: '100%' }}>
        <DataGrid
          rows={this.props.partnerSelected.commissionSettings}
          columns={this.columns}
          components={{
            Toolbar: CustomToolbar
          }}
          componentsProps={{ toolbar: { createNew: this.create } }}
          checkboxSelection
          disableSelectionOnClick
        />
        <CreateCommissionSettings></CreateCommissionSettings>
        <EditCommissionSettings></EditCommissionSettings>
        <ConfirmDialog
          IsOpen={this.state.IsOpenConfirmDialog}
          close={() => this.setState({ IsOpenConfirmDialog: false, ID: null })}
          confirm={() => {
            this.props.deleteCommissionSettings(this.state.ID);
            this.setState({ IsOpenConfirmDialog: false, ID: null });
          }}
          message={'Da li ste sigurni da želite da obrišete ovaj unos?'}
        />
      </div>
    );
  }
}

const mapStateToProps = state => {
  return {
    //commissionSettings: Object.values(state.commissionSettings),
    //partners: Object.values(state.partnersSelectBox), 
    loanTypes: Object.values(state.loanTypesSelectBox),
    partnerSelected: state.partnerSelected
  };
}

export default connect(mapStateToProps, {
  addDialogCommissionSettings,
  editDialogCommissionSettings,
  deleteCommissionSettings,
  getSelectBoxLoanTypes
})(TableCommissionSettings);